import { dwmRepository, AppIntegrationsRepository, MeRepository, AppPricesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

angular.module('controllers')
    .controller('Dwm', ($http, Util, $scope, $rootScope, $state, $location, $anchorScroll) => {

        const aviraToken = Util.getToken();

        $scope.loadingButton = false;

        $scope.appIntegration = AppIntegrationsRepository.getById('adwp1') || {};
        $scope.currentTab = $state.params.tab || 'dwm';

        $rootScope.dwmResoucesStatuses = {
            token: 'loading',
            members: false,
            alerts: false,
        };

        const user = MeRepository.getMyUser();
        const userLanguage = Util.deepFind(user, 'attributes.language');

        $scope.isUserCountryUS = Util.deepFind(user, 'attributes.country') === 'US';

        $scope.currentTab = $state.params.tab || 'dwm';

        $scope.changeTab = (tab) => {

            $scope.currentTab = tab;

        };

        $scope.currentPrice = AppPricesRepository.getSinglePrice('adwp1', '12', '1');

        $scope.onlineSurvey = 'https://www.nortonlifelock.com/ca/en/newsroom/press-kits/2021-norton-cyber-safety-insights-report/';
        $scope.personalData = userLanguage === 'de' ?
            'https://www.avira.com/de/blog/daten-im-darknet-wieviel-ist-ihre-kreditkarte-wert' :
            'https://www.avira.com/en/blog/data-and-the-dark-web-how-much-is-your-personal-data-worth';

        $rootScope.alertsActivePage = 1;

        $scope.toggleMontoring = () => {

            if ($scope.activateLicensePending) {

                return;

            }

            if ($scope.aiaSubscriptioneStatus === 'active' ||
                $scope.dwmLiteSubscriptionStatus === 'active') {

                $state.go('root.dashboard.dwm.ltb', {
                    ltb: 'toggle-monitoring',
                    resourceId: 'monitoring',
                }, {
                    reload: false,
                });

                Mixpanel.send('ConnectWeb AIA Monitoring Click', {
                    'Button Label': 'Deactivate',
                });

            }

            if ($scope.aiaSubscriptionCancelled || $scope.dwmLiteSubscriptionCancelled) {

                $scope.activateLicensePending = true;

                Mixpanel.send('ConnectWeb AIA Monitoring Click', {
                    'Button Label': 'Activate',
                });

                $http({
                    method: 'POST',
                    url: CWCONFIG.dwm.enrollURL,
                    headers: {
                        Authorization: `Bearer ${aviraToken}`,
                    },
                    data: {
                        clientApplication: {
                            clientId: 'myavira',
                        },
                    },

                }).then(() => {

                    if ($scope.aiaSubscriptionCancelled) {

                        $rootScope.dwmStatus.products.identityAssist.subscriptionStatus = 'active';
                        $rootScope.aiaSubscriptionCancelled = false;
                        $scope.aiaSubscriptionCancelled = false;

                    }

                    if ($scope.dwmLiteSubscriptionCancelled) {

                        $rootScope.dwmStatus.products.dwmLite.subscriptionStatus = 'active';
                        $rootScope.dwmLiteSubscriptionCancelled = false;
                        $scope.dwmLiteSubscriptionCancelled = false;

                    }

                    $rootScope.aiaStatusApiCall();

                    $scope.activateLicensePending = false;

                }).catch((errResponse) => {

                    $scope.activateLicensePending = false;
                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                    Mixpanel.send('ConnectWeb AIA Error', {
                        Detail: 'activate',
                        ErrorCode: errResponse.data ? errResponse.data.errorCode : 'N/A',
                        ErrorMessage: errResponse.data ? errResponse.data.message : 'N/A',
                        ErrorDescription: errResponse.data ? errResponse.data.error_description : 'N/A',
                        ErrorTrackId: errResponse.data ? errResponse.data.trackId : 'N/A',
                        ErrorStatus: errResponse.data ? errResponse.data.status : 'N/A',
                    });

                });

            }

        };

        const sendDashboardOpenEvent = () => {

            let monitoring;
            if ($scope.aiaSubscriptionCancelled || $scope.dwmLiteSubscriptionCancelled) {

                monitoring = 'Off';

            } else if ($scope.aiaSubscriptionActive || $scope.dwmLiteSubscriptionActive) {

                monitoring = 'On';

            }

            if ($scope.currentTab !== 'store') {

                Mixpanel.send('ConnectWeb AIA Dashboard Open', {
                    Tab: $scope.currentTab,
                    'AIA Version': $rootScope.showDWMLiteStrippedDashboard || $rootScope.showDWMLiteUpsellDashboard ? 'DWM Lite' : 'AIA',
                    'AIA Monitoring': monitoring,
                });

            }

        };

        if ($scope.currentTab === 'faq') {

            sendDashboardOpenEvent();

        }

        Promise.allSettled = (promises) => {

            const mappedPromises = promises.map(p => p
                .then(value => ({
                    status: 'fulfilled',
                    value,
                }))
                .catch(reason => ({
                    status: 'rejected',
                    reason,
                })));
            return Promise.all(mappedPromises);

        };

        const getDarkWebMonitorData = () => {

            if ($scope.showUpsellPageFlag) {

                return;

            }

            $http({
                method: 'POST',
                url: `${CWCONFIG.dwm.restApi}/v1/auth/tokensByPartnerToken`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    'Content-Type': 'application/json',
                },
                data: {
                    partner_token: aviraToken,
                },

            }).then((response) => {

                $rootScope.dwmNortonToken = response.data.access_token;
                $rootScope.dwmResoucesStatuses.token = 'loaded';
                $rootScope.dwmResoucesStatuses.members = 'loading';
                $rootScope.dwmResoucesStatuses.alerts = 'loading';

                const assetsPromise = $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);

                    if ($scope.aiaSubscriptionActive) {

                        const { monitoredAccounts, dwmCardStatus } =
                            membersResponse.data.primaryMember;

                        Mixpanel.setCommonProperty('AIA Asset Email', monitoredAccounts.emails.entries.length + 1);
                        Mixpanel.setCommonProperty('AIA Asset Phone', monitoredAccounts.phoneNumbers.entries.length);
                        Mixpanel.setCommonProperty('AIA Asset Credit Card', monitoredAccounts.creditDebitCards.entries.length);
                        Mixpanel.setCommonProperty('AIA Asset Bank Account', monitoredAccounts.bankAccounts.entries.length);
                        Mixpanel.setCommonProperty('AIA Asset Address', monitoredAccounts.addresses.entries.length);
                        Mixpanel.setCommonProperty('AIA Asset Driver License', monitoredAccounts.driversLicense.entries.length);
                        Mixpanel.setCommonProperty('AIA Asset Gamer Tag', monitoredAccounts.gamerTags.entries.length);
                        Mixpanel.setCommonProperty('AIA Asset Insurance', monitoredAccounts.insuranceCards.entries.length);
                        Mixpanel.setCommonProperty('AIA Asset Mothers Name', monitoredAccounts.mothersMaidenName.entries.length);

                        if (dwmCardStatus === 'add-more-data') {

                            $rootScope.showDwmCardHomepage = true;
                            $rootScope.showDwmAddMoreDataCard = true;

                        }

                    } else if ($scope.dwmLiteSubscriptionActive) {

                        Mixpanel.setCommonProperty('AIA Asset Email', 1);

                    }

                    $rootScope.dwmResoucesStatuses.members = 'loaded';
                    $scope.loadingButton = false;
                    const { email } = user.attributes;
                    const { primaryEmail } = membersResponse.data.primaryMember;

                    if (email !== primaryEmail.emailAddress) {

                        const payloadEmail = {
                            primaryEmail: {
                                emailAddress: email,
                                type: 'OTHER',
                            },
                        };

                        $http({
                            method: 'PUT',
                            url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                            headers: {
                                client_id: 'avira',
                                origin: 'https://avira.com',
                                access_token: $rootScope.dwmNortonToken,
                                'Content-Type': 'application/json',
                            },
                            data: payloadEmail,
                        }).then(() => {

                            $http({
                                method: 'GET',
                                url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                                headers: {
                                    client_id: 'avira',
                                    origin: 'https://avira.com',
                                    access_token: $rootScope.dwmNortonToken,
                                    'Content-Type': 'application/json',
                                },

                            }).then((membersEmailResponse) => {

                                dwmRepository.replace('assets', membersEmailResponse.data);
                                $rootScope.dwmResoucesStatuses.members = 'loaded';
                                $scope.loadingButton = false;


                            }).catch(() => {

                                $rootScope.dwmResoucesStatuses.members = 'error';
                                $scope.loadingButton = false;

                                Alert.error('cw.modal.server-error.desc');

                            });

                        }).catch(() => {


                            Alert.error('cw.modal.server-error.desc');


                        });

                    } else {

                        dwmRepository.replace('assets', membersResponse.data);
                        $rootScope.dwmResoucesStatuses.members = 'loaded';
                        $scope.loadingButton = false;

                    }

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/piiFieldRules?countryCode=${'DE'}`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((validationResponse) => {

                        dwmRepository.replace('validation', validationResponse.data);

                    }).catch(() => {

                        $rootScope.dwmResoucesStatuses.members = 'loading';
                        Alert.error('cw.modal.server-error.desc');

                    });

                }).catch((errResponse) => {

                    $rootScope.dwmResoucesStatuses.members = 'loading';
                    $scope.loadingButton = false;

                    Alert.error('cw.modal.server-error.desc');

                    Mixpanel.send('ConnectWeb AIA Error', {
                        Detail: 'members',
                        ErrorCode: errResponse.data ? errResponse.data.errorCode : 'N/A',
                    });

                });

                const alertsPromise = $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/alerts`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                        lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US',
                    },

                }).then((alertsResponse) => {

                    dwmRepository.replace('alerts', alertsResponse.data);
                    $rootScope.dwmResoucesStatuses.alerts = 'loaded';

                    let aiaUnreadAlerts = 0;
                    let aiaReadAlerts = 0;

                    if (alertsResponse.data.alertList.length > 0) {

                        alertsResponse.data.alertList.forEach((alert) => {

                            if (alert.isRead === false && alert.bucket === 'inbox') {

                                aiaUnreadAlerts += 1;

                            }

                        });

                        aiaReadAlerts = alertsResponse.data.alertList.length - aiaUnreadAlerts;

                    }

                    if (aiaUnreadAlerts > 0) {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmUnreadNotificationsCard = true;
                        $rootScope.dwmCardUnreadNotifications = aiaUnreadAlerts;

                    } else if (aiaUnreadAlerts === 0 && $scope.dwmLiteSubscriptionUpsell) {

                        $rootScope.showDwmCardHomepage = true;

                    }

                    if ($rootScope.scrollToNotifications) {

                        // Scroll to the notifications section
                        $location.hash('notifications');
                        $anchorScroll();

                        // Reset the scroll behaviour
                        $rootScope.scrollToNotifications = false;
                        $location.hash('');

                    }

                    Mixpanel.setCommonProperty('AIA Unread Alerts', aiaUnreadAlerts);
                    Mixpanel.setCommonProperty('AIA Read Alerts', aiaReadAlerts);

                }).catch((errResponse) => {

                    $rootScope.dwmResoucesStatuses.alerts = 'error';
                    Alert.error('cw.modal.server-error.desc');

                    Mixpanel.send('ConnectWeb AIA Error', {
                        Detail: 'alerts',
                        ErrorCode: errResponse.data ? errResponse.data.errorCode : 'N/A',
                    });

                });

                Promise.allSettled([assetsPromise, alertsPromise]).then(() => {

                    sendDashboardOpenEvent();

                });

            }).catch((response) => {

                if ($scope.aiaSubscriptioneStatus === 'cancelled') {

                    $rootScope.dwmResoucesStatuses.members = 'loaded';
                    $scope.loadingButton = false;

                }

                $rootScope.dwmResoucesStatuses.token = 'error';

                $scope.loadingButton = false;

                if (response.data.errorCode !== 32030) {

                    Mixpanel.send('ConnectWeb AIA Error', {
                        Detail: 'tokensByPartnerToken',
                        ErrorCode: response.data ? response.data.errorCode : 'N/A',
                    });

                    Alert.error('cw.modal.server-error.desc');

                } else {

                    sendDashboardOpenEvent();

                }

            });

        };

        let refreshPartnerToken;
        // status api code
        $rootScope.aiaStatusApiCall = (triggerPendingState) => {

            $scope.showMainLoader = true;

            if (triggerPendingState) {

                $scope.activateLicensePending = true;

            }

            $http({
                method: 'POST',
                url: CWCONFIG.dwm.statusURL,
                headers: {
                    Authorization: `Bearer ${aviraToken}`,
                },
                data: {
                    clientApplication: {
                        clientId: 'myavira',
                    },
                },

            }).then((response) => {

                const dwmStatus = response.data;

                const aiaStatus = Util.deepFind(dwmStatus, 'products.identityAssist');
                const dwmLiteStatus = Util.deepFind(dwmStatus, 'products.dwmLite');

                if (!aiaStatus && !dwmLiteStatus) {

                    $state.go('root.dashboard.home');

                }

                dwmRepository.replace('statusApi', dwmStatus);

                if (aiaStatus || dwmLiteStatus) {

                    $rootScope.showDwmLeftNavigation = true;

                }

                $scope.showMainLoader = false;
                $scope.dwmStatus = dwmStatus;
                $rootScope.dwmStatus = dwmStatus;

                const aiaTileAction = Util.deepFind($rootScope.dwmStatus, 'products.identityAssist.tileAction');
                const dwmLiteTileAction = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.tileAction');

                $scope.dwmLiteSubscriptionStatus = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.subscriptionStatus');
                $scope.aiaSubscriptioneStatus = Util.deepFind($rootScope.dwmStatus, 'products.identityAssist.subscriptionStatus');

                $scope.aiaSubscriptionCancelled = $scope.aiaSubscriptioneStatus === 'cancelled' || $scope.aiaSubscriptioneStatus === 'none';
                $scope.aiaSubscriptionActive = $scope.aiaSubscriptioneStatus === 'active';
                $scope.dwmLiteSubscriptionCancelled = $scope.dwmLiteSubscriptionStatus === 'cancelled' || $scope.dwmLiteSubscriptionStatus === 'none';
                $scope.dwmLiteSubscriptionActive = $scope.dwmLiteSubscriptionStatus === 'active';
                $scope.dwmLiteSubscriptionUpsell = $scope.dwmLiteSubscriptionStatus === 'active' && aiaTileAction === 'openUpsell';

                $rootScope.aiaSubscriptionCancelled = $scope.aiaSubscriptioneStatus === 'cancelled' || $scope.aiaSubscriptioneStatus === 'none';

                $rootScope.dwmLiteSubscriptionCancelled = $scope.dwmLiteSubscriptionStatus === 'cancelled' || $scope.dwmLiteSubscriptionStatus === 'none';

                if ((aiaStatus || dwmLiteStatus) &&
                    ($rootScope.aiaSubscriptionCancelled ||
                        $rootScope.dwmLiteSubscriptionCancelled)) {

                    $rootScope.showDwmCardHomepage = true;

                } else {

                    $rootScope.showDwmCardHomepage = false;

                }

                if (aiaTileAction === 'openUpsell' || dwmLiteTileAction === 'openUpsell') {

                    $rootScope.showAIAWelcomeOfferBanner = true;

                } else {

                    $rootScope.showAIAWelcomeOfferBanner = false;

                }

                if (aiaTileAction === 'openDashboard') {

                    // show aia dashboard
                    getDarkWebMonitorData();
                    $scope.showUpsellPage = false;
                    $scope.showUpsellPageFlag = false;
                    $rootScope.showDWMDashboard = true;
                    $rootScope.showDWMLiteStrippedDashboard = false;
                    $rootScope.showDWMLiteUpsellDashboard = false;

                    if ($scope.aiaSubscriptioneStatus === 'active') {

                        refreshPartnerToken = setInterval(getDarkWebMonitorData, 600000);

                    } else {

                        clearInterval(refreshPartnerToken);

                    }

                    if ($scope.currentTab === 'store') {

                        $state.go('root.dashboard.dwm', {
                            tab: 'dwm',
                        });

                    }

                } else if (dwmLiteTileAction === 'openDashboard') {

                    // show dwm lite dashboard
                    if ($scope.dwmLiteSubscriptionStatus === 'active') {

                        getDarkWebMonitorData();
                        $scope.showUpsellPage = false;
                        $scope.showUpsellPageFlag = false;

                        if ($scope.dwmLiteSubscriptionStatus === 'active') {

                            refreshPartnerToken = setInterval(getDarkWebMonitorData, 600000);

                        } else {

                            clearInterval(refreshPartnerToken);

                        }

                    } else {

                        sendDashboardOpenEvent();

                    }

                    if (aiaTileAction === 'openUpsell') {

                        // show aia upsell
                        $rootScope.showDWMLiteUpsellDashboard = true;

                        if ($scope.currentTab === 'restoration') {

                            $state.go('root.dashboard.dwm', {
                                tab: 'store',
                            });

                        }

                    } else {

                        // show dwm lite - stripped version, no upsell, only email
                        $rootScope.showDWMLiteStrippedDashboard = true;

                        if ($scope.currentTab === 'restoration') {

                            $state.go('root.dashboard.dwm', {
                                tab: 'dwm',
                            });

                        }

                        if ($scope.currentTab === 'store') {

                            $state.go('root.dashboard.dwm', {
                                tab: 'dwm',
                            });

                        }

                    }

                } else if (aiaTileAction === 'openUpsell') {

                    // show aia store page
                    $scope.showUpsellPage = true;

                    $state.go('root.dashboard.dwm', {
                        tab: 'store',
                    });

                }

                if (triggerPendingState) {

                    $scope.activateLicensePending = false;

                }

                if ($rootScope.turnOnDwm) {

                    $rootScope.turnOnDwm = false;
                    $scope.toggleMontoring();

                }

            }).catch((response) => {

                Mixpanel.send('ConnectWeb AIA Error', {
                    Detail: 'statusAPI',
                    ErrorCode: response.data ? response.data.errorCode : 'N/A',
                    ErrorMessage: response.data ? response.data.message : 'N/A',
                    ErrorDescription: response.data ? response.data.error_description : 'N/A',
                    ErrorTrackId: response.data ? response.data.trackId : 'N/A',
                    ErrorStatus: response.data ? response.data.status : 'N/A',
                });

                Alert.error('cw.modal.server-error.desc');

                $rootScope.showDwmLeftNavigation = false;

                $state.go('root.dashboard.home');

            });

        };

        $rootScope.aiaStatusApiCall();
        // end status api code

        $scope.buy = (button, appId) => {

            appId = 'adwp1';
            const mixpanelData = {
                'Product ID': appId,
                Page: 'AIA Store Page',
                Runtimes: 12,
            };

            Mixpanel.send('ConnectWeb Store Buy Click', mixpanelData);

            const subsource = 'store';

            $state.go('root.dashboard.dwm.ltb.buy', {
                ltb: 'payment-cart',
                resourceId: appId,
                subsource,
                button,
            }, {
                reload: false,
            });

        };


        const purchaseListener = $rootScope.$on('dwm_purchase_completed', () => {

            $rootScope.aiaStatusApiCall();

        });

        $scope.sendMixpanelSupport = () => {

            Mixpanel.send('ConnectWeb AIA Restoration Contact Click');

        };

        $rootScope.showUpsellPageClick = (label) => {

            $scope.showUpsellPageFlag = true;
            $rootScope.redirectFromTab = $scope.currentTab;

            Mixpanel.send('ConnectWeb DWM Lite Upgrade Click', {
                Label: label,
            });

            $state.go('root.dashboard.dwm', {
                tab: 'store',
            });

        };

        $scope.restorationTabClick = () => {

            if (!$rootScope.showDWMLiteUpsellDashboard &&
                !$rootScope.showDWMLiteStrippedDashboard) {

                $state.go('root.dashboard.dwm', {
                    tab: 'restoration',
                }, {
                    reload: false,
                });

            } else if ($rootScope.showDWMLiteUpsellDashboard) {

                $scope.showUpsellPageFlag = true;
                $rootScope.redirectFromTab = $scope.currentTab;

                Mixpanel.send('ConnectWeb DWM Lite Upgrade Click', {
                    Label: 'Restoration Tab',
                });

                $state.go('root.dashboard.dwm', { tab: 'store' });

            }

        };

        $scope.sendMixpanelLearnMore = () => {

            Mixpanel.send('ConnectWeb AIA Learn More Click');

        };

        // $rootScope.createCMAlabels('adwp1_12_1', 'Avira Identity Assistant',
        // 'adwp1', '2023-06-08', '2023-06-30');

        $scope.$on('$destroy', () => {

            $rootScope.extraCMAinfoForDwm = false;
            clearInterval(refreshPartnerToken);
            purchaseListener();

            // $rootScope.welcomeOffers = {};

            $rootScope.offersDetails = [];

        });

    });



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/dwm/dwm.js